import React from 'react';
import Button from '@material-ui/core/Button';
import {browserHistory} from 'react-router';
import {Link} from 'react-router';
import 'styles/admin/DepartmentProfileList.styl';

export default class DepartmentProfileList extends React.PureComponent {
  selectProfile({id}) {
    const {profileIdName} = this.props;
    const department = this.props.department.set(profileIdName, id);
    this.props.updateDepartment(department).then(() => {
      browserHistory.push(`/admin/departments/edit/${department.id}`);
    });
  }
  render() {
    if (this.props.profiles.size === 0) {
      return (
        <div className="department-profiles-list">You don't have any defined profiles yet.</div>
      );
    }
    return (
      <ul className="department-profiles-list">
        {this.props.profiles.map(profile => (
          <li key={profile.id}>
            <Link to={window.location.pathname + '/edit/' + profile.id} className="generic-link">
              {profile.name}
            </Link>
            {this.props.hasDepartmentContext && this.props.department ? (
              this.props.department[this.props.profileIdName] === profile.id ? (
                <span className="current-selection">Current</span>
              ) : (
                <div>
                  <Button
                    variant="outlined"
                    className="ev-button"
                    disabled={this.props.isDepartmentSaving}
                    onClick={() => this.selectProfile(profile)}>
                    Select
                  </Button>
                </div>
              )
            ) : null}
          </li>
        ))}
      </ul>
    );
  }
}
